export const CATEGORY_INSTRUCTION_EXAMPLES = [
    {
        label: 'Collagen',
        text: 'Track how collagen is showing up across ingestibles and skincare. Include launches, claims, formats, ingredients, and retailer signals. Exclude clinical or B2B uses that are not consumer-facing.',
    },
    {
        label: 'Peptide skincare',
        text: 'Focus on peptide-led skincare and adjacent “firming” or “repair” positioning. Include new product launches, hero claims, ingredient pairings, expert commentary, and premium vs masstige brand activity. Exclude generic hydration content without a peptide angle.',
    },
    {
        label: 'Sleep gummies',
        text: 'Monitor sleep gummies and other bedtime supplement formats. Include ingredients, flavor and format innovation, consumer claims, retailer momentum, and social discussion. Exclude prescription sleep treatments and general wellness news without a sleep supplement focus.',
    },
];

export const CATEGORY_INSTRUCTIONS_PLACEHOLDER =
    'e.g. Track how collagen is showing up across ingestibles and skincare. Include launches, claims, and retailer signals. Exclude clinical or B2B uses.';
